export default (value: number): string => {
  if (value === null || value === undefined) return '';
  return value.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
};
